import { render } from "./RegisterOrUploadIso.vue?vue&type=template&id=4c18ce0a&scoped=true"
import script from "./RegisterOrUploadIso.vue?vue&type=script&lang=js"
export * from "./RegisterOrUploadIso.vue?vue&type=script&lang=js"

import "./RegisterOrUploadIso.vue?vue&type=style&index=0&id=4c18ce0a&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c18ce0a"]])

export default __exports__